var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "el-container",
    { staticClass: "audit-style" },
    [
      _c(
        "el-aside",
        {
          staticClass: "aside-left",
          style: { height: _vm.boxHeight },
          attrs: { width: "3.20rem" }
        },
        [
          _c("p", { staticClass: "page-total" }, [
            _c("span", { staticClass: "tit" }, [_vm._v("签署文件列表")]),
            _c("span", [_vm._v("（共" + _vm._s(_vm.fileList.length) + "个）")])
          ]),
          _c("div", { staticClass: "aside-left_flex" }, [
            _c(
              "div",
              {
                staticClass: "page-con",
                style: { height: _vm.leftCSideHeight }
              },
              [
                _vm._l(_vm.fileList, function(file, i) {
                  return [
                    _c(
                      "div",
                      {
                        key: i,
                        staticClass: "list",
                        class: _vm.checkAct === i ? "active" : "",
                        on: {
                          click: function($event) {
                            return _vm.chooseFile(file, i)
                          }
                        }
                      },
                      [
                        _c("div", { staticClass: "bx" }, [
                          _vm.fileSuffix(file.fileName) === "pdf"
                            ? _c("img", {
                                attrs: {
                                  src: "/images/advancedVersion/pdf.png"
                                }
                              })
                            : _vm._e(),
                          _vm.fileSuffix(file.fileName) === "wps"
                            ? _c("img", {
                                attrs: {
                                  src: "/images/advancedVersion/WPS.png"
                                }
                              })
                            : _vm._e(),
                          _vm.fileSuffix(file.fileName) === "jpg"
                            ? _c("img", {
                                attrs: {
                                  src: "/images/advancedVersion/JPG.png"
                                }
                              })
                            : _vm._e(),
                          _vm.fileSuffix(file.fileName) === "doc" ||
                          _vm.fileSuffix(file.fileName) === "docx"
                            ? _c("img", {
                                attrs: {
                                  src: "/images/advancedVersion/word.png"
                                }
                              })
                            : _vm._e(),
                          _vm.fileSuffix(file.fileName) === "xlsx" ||
                          _vm.fileSuffix(file.fileName) === "xls"
                            ? _c("img", {
                                attrs: {
                                  src: "/images/advancedVersion/xlsx.png"
                                }
                              })
                            : _vm._e()
                        ]),
                        _c(
                          "p",
                          {
                            staticClass: "title",
                            attrs: { title: file.fileName }
                          },
                          [_vm._v(_vm._s(file.fileName))]
                        )
                      ]
                    )
                  ]
                })
              ],
              2
            ),
            _c(
              "div",
              [
                _c("transition", { attrs: { name: "el-zoom-in-top" } }, [
                  _c(
                    "div",
                    {
                      staticClass: "list-pages",
                      style: { height: _vm.leftCSideHeight }
                    },
                    [
                      _vm._l(_vm.contractInfoTemporary.items, function(i) {
                        return [
                          _c(
                            "div",
                            {
                              key: i,
                              staticClass: "listDetail",
                              class: _vm.currentInfo.page === i ? "active" : "",
                              on: {
                                click: function($event) {
                                  return _vm.getContractDetailByNum(i)
                                }
                              }
                            },
                            [
                              _c("img", { attrs: { src: _vm.imgShowFn(i) } }),
                              _c("span", [_vm._v(_vm._s(i))])
                            ]
                          )
                        ]
                      })
                    ],
                    2
                  )
                ])
              ],
              1
            )
          ])
        ]
      ),
      _c("transition", { attrs: { name: "el-fade-in" } }, [
        _c("div", {
          directives: [
            {
              name: "show",
              rawName: "v-show",
              value: _vm.drawerShow,
              expression: "drawerShow"
            }
          ],
          staticClass: "aside",
          style: { height: _vm.boxHeight }
        })
      ]),
      _c("transition", { attrs: { name: "my" } }, [
        _c(
          "div",
          {
            directives: [
              {
                name: "show",
                rawName: "v-show",
                value: _vm.drawerShow,
                expression: "drawerShow"
              }
            ],
            staticClass: "aside-content",
            style: { height: _vm.boxHeight }
          },
          [
            _c(
              "div",
              { staticClass: "aside-top" },
              [
                _vm.tabIndex === 1
                  ? [_vm._v("\n            签署状态\n          ")]
                  : _vm._e(),
                _vm.tabIndex === 2
                  ? [
                      _vm._v(
                        "\n            仅供参与方查阅，不用于签署（共 " +
                          _vm._s(this.enclosureList.length) +
                          " 份）\n          "
                      )
                    ]
                  : _vm._e(),
                _vm.notShowFlowInfo
                  ? [_vm._v("\n            审批详情\n          ")]
                  : _vm._e(),
                _c("span", {
                  staticClass: "el-icon-error",
                  on: { click: _vm.closeTabBox }
                })
              ],
              2
            ),
            _c(
              "div",
              {
                staticClass: "aside-box",
                style: { height: _vm.mainHeight - 60 + "px" }
              },
              [
                _vm.tabIndex === 2
                  ? _c(
                      "div",
                      { staticClass: "enclosure-box" },
                      [
                        _vm._l(_vm.enclosureList, function(item, index) {
                          return _c(
                            "div",
                            { key: index, staticClass: "enclosure-item" },
                            [
                              _c("div", { staticClass: "li-preview" }, [
                                _vm.isImg(item) || _vm.isVideo(item)
                                  ? _c("span", {
                                      staticClass: "el-icon-view",
                                      attrs: { title: "预览" },
                                      on: {
                                        click: function($event) {
                                          return _vm.previewVideOrImg(item)
                                        }
                                      }
                                    })
                                  : _vm._e(),
                                _vm.isDoc(item)
                                  ? _c("span", {
                                      staticClass: "el-icon-view",
                                      attrs: { title: "预览" },
                                      on: {
                                        click: function($event) {
                                          return _vm.previewDoc(item)
                                        }
                                      }
                                    })
                                  : _vm._e(),
                                _c(
                                  "a",
                                  {
                                    attrs: {
                                      href: _vm.downloadAttatchFile(item.file),
                                      target: "_blank"
                                    }
                                  },
                                  [
                                    _c("span", {
                                      staticClass: "el-icon-download",
                                      attrs: { title: "下载" }
                                    })
                                  ]
                                )
                              ]),
                              _c("div", { staticClass: "li-con" }, [
                                _c("div", { staticClass: "t-do" }, [
                                  _vm._v(_vm._s(_vm.getEnclosureSuffix(item)))
                                ]),
                                _c(
                                  "h1",
                                  { attrs: { title: item.file.fileName } },
                                  [_vm._v(_vm._s(item.file.fileName))]
                                )
                              ])
                            ]
                          )
                        }),
                        _vm.enclosureList.length === 0
                          ? _c("no-data", {
                              attrs: { slot: "empty", text: "暂无数据" },
                              slot: "empty"
                            })
                          : _vm._e()
                      ],
                      2
                    )
                  : _vm._e(),
                _vm.tabIndex === 1
                  ? _c("div", { staticClass: "signingFlow-box" }, [
                      _c("div", { staticClass: "signingFlow-top" }, [
                        _c("span", [_vm._v("签署流程示意图")])
                      ]),
                      _c("div", { staticClass: "signingFlow-tit" }, [
                        _c("img", {
                          staticClass: "photo",
                          attrs: { src: "/images/web/p-default.png" }
                        }),
                        _c("p", [_vm._v(_vm._s(_vm.detailInfo.ebqUserName))])
                      ]),
                      _c("h4", [_vm._v("发起方")]),
                      _c("div", { staticClass: "arr-down" }, [
                        _c("i", { staticClass: "el-icon-arrow-down" })
                      ]),
                      _vm.detailInfo.signInfos &&
                      _vm.detailInfo.signInfos.length !== 0
                        ? _c(
                            "div",
                            { staticClass: "signingFlow" },
                            _vm._l(_vm.detailInfo.signInfos, function(
                              item,
                              index
                            ) {
                              return _c(
                                "div",
                                {
                                  key: index,
                                  staticClass: "signingFlow-item",
                                  class: _vm.detailInfo.orderFlag
                                    ? "orderLi"
                                    : ""
                                },
                                [
                                  item.hasOwnProperty("fullName")
                                    ? _c(
                                        "div",
                                        { staticClass: "signing-flow-tit" },
                                        [
                                          _c("img", {
                                            staticClass: "photo",
                                            attrs: {
                                              src: "/images/web/p-default.png"
                                            }
                                          }),
                                          _c(
                                            "el-tooltip",
                                            {
                                              attrs: {
                                                effect: "light",
                                                placement: "bottom-end"
                                              }
                                            },
                                            [
                                              _c(
                                                "div",
                                                {
                                                  attrs: { slot: "content" },
                                                  slot: "content"
                                                },
                                                [
                                                  _vm._v(
                                                    "\n                      名称：" +
                                                      _vm._s(item.fullName) +
                                                      " "
                                                  ),
                                                  _c("br"),
                                                  _vm._v(
                                                    "\n                      证件号：" +
                                                      _vm._s(
                                                        item.identityCardMask
                                                      ) +
                                                      " "
                                                  ),
                                                  _c("br"),
                                                  _vm._v(
                                                    "\n                      接收手机或邮箱：" +
                                                      _vm._s(
                                                        item.mobileMask ||
                                                          item.emailMask
                                                      ) +
                                                      "\n                    "
                                                  )
                                                ]
                                              ),
                                              _c("p", [
                                                _vm._v(
                                                  _vm._s(
                                                    item.fullName ||
                                                      "请输入签署方名称"
                                                  )
                                                )
                                              ])
                                            ]
                                          )
                                        ],
                                        1
                                      )
                                    : _c(
                                        "div",
                                        { staticClass: "signing-flow-tit" },
                                        [
                                          _c("img", {
                                            staticClass: "photo",
                                            attrs: {
                                              src: "/images/web/p-default.png"
                                            }
                                          }),
                                          _c("p", [_vm._v("批量签署方")])
                                        ]
                                      ),
                                  _c(
                                    "p",
                                    [
                                      item.signStatus == 1
                                        ? [
                                            _c(
                                              "span",
                                              {
                                                staticStyle: {
                                                  color: "#76D0D0"
                                                }
                                              },
                                              [_vm._v("已签署")]
                                            )
                                          ]
                                        : item.signStatus == 2
                                        ? [
                                            _c(
                                              "span",
                                              {
                                                staticStyle: {
                                                  color: "#EC1C1C"
                                                }
                                              },
                                              [_vm._v("已拒绝")]
                                            )
                                          ]
                                        : [
                                            _c(
                                              "span",
                                              {
                                                staticStyle: {
                                                  color: "#999999"
                                                }
                                              },
                                              [_vm._v("未签署")]
                                            )
                                          ]
                                    ],
                                    2
                                  )
                                ]
                              )
                            }),
                            0
                          )
                        : _vm._e(),
                      _c("div", { staticClass: "arr-down" }, [
                        _c("i", { staticClass: "el-icon-arrow-down" })
                      ]),
                      _c(
                        "span",
                        {
                          staticClass: "signStatus",
                          class: "s" + _vm.detailInfo.signStatus
                        },
                        [_vm._v(_vm._s(_vm.statusText))]
                      ),
                      _vm.detailInfo.signStatus === 2
                        ? _c("div", { staticClass: "signingFlow" }, [
                            _vm._v(
                              "\n              拒签理由：" +
                                _vm._s(_vm.detailInfo.refusedReason || "") +
                                "\n            "
                            )
                          ])
                        : _vm._e()
                    ])
                  : _vm._e(),
                _vm.tabIndex === 3
                  ? _c(
                      "div",
                      { staticClass: "enclosure-box" },
                      [
                        !_vm.isInDingTalk
                          ? _c("audit-detail", {
                              attrs: { auditor: _vm.auditDetailInfo }
                            })
                          : _vm._e(),
                        _vm.isInDingTalk
                          ? _c("ding-audit-detail", {
                              attrs: {
                                auditor: _vm.auditDetailInfo,
                                applyInfo: _vm.detailInfo
                              }
                            })
                          : _vm._e()
                      ],
                      1
                    )
                  : _vm._e()
              ]
            )
          ]
        )
      ]),
      _c(
        "div",
        { staticClass: "aside-tab", class: _vm.drawerShow ? "open" : "close" },
        [
          _c(
            "div",
            {
              staticClass: "tab",
              class: _vm.drawerShow && _vm.tabIndex !== 1 ? "black" : "",
              on: {
                click: function($event) {
                  return _vm.tabHandleClick(1)
                }
              }
            },
            [
              _c("span", { staticClass: "word" }, [_vm._v("签署状态")]),
              _c("i", {
                class:
                  _vm.tabIndex === 1
                    ? "el-icon-arrow-left"
                    : "el-icon-arrow-right"
              })
            ]
          ),
          _vm.enclosureList.length > 0
            ? _c(
                "div",
                {
                  staticClass: "tab",
                  class: _vm.drawerShow && _vm.tabIndex !== 2 ? "black" : "",
                  on: {
                    click: function($event) {
                      return _vm.tabHandleClick(2)
                    }
                  }
                },
                [
                  _c("span", { staticClass: "word" }, [_vm._v("附属材料")]),
                  _c("i", {
                    class:
                      _vm.tabIndex === 2
                        ? "el-icon-arrow-left"
                        : "el-icon-arrow-right"
                  })
                ]
              )
            : _vm._e(),
          _vm.$route.query.approveId
            ? _c(
                "div",
                {
                  staticClass: "tab",
                  class: _vm.drawerShow && _vm.tabIndex !== 3 ? "black" : "",
                  on: {
                    click: function($event) {
                      return _vm.tabHandleClick(3)
                    }
                  }
                },
                [
                  _c("span", { staticClass: "word" }, [_vm._v("审批详情")]),
                  _c("i", {
                    class:
                      _vm.tabIndex === 3
                        ? "el-icon-arrow-left"
                        : "el-icon-arrow-right"
                  })
                ]
              )
            : _vm._e()
        ]
      ),
      _c(
        "el-main",
        {
          ref: "contrBody",
          staticClass: "main-box",
          style: { height: _vm.mainHeight + "px" }
        },
        [
          _c("contract-view", {
            ref: "contractView",
            attrs: {
              "chapter-list": _vm.chapteJson,
              "contract-info": _vm.currentInfo,
              items: _vm.contractInfoTemporary.items,
              page: _vm.currentInfo.page,
              scaleValue: _vm.scaleValue,
              targetId: _vm.contractInfoTemporary.targetId,
              "is-detail": true
            },
            on: {
              "update:chapterList": function($event) {
                _vm.chapteJson = $event
              },
              "update:chapter-list": function($event) {
                _vm.chapteJson = $event
              },
              "update:contractInfo": function($event) {
                _vm.currentInfo = $event
              },
              "update:contract-info": function($event) {
                _vm.currentInfo = $event
              },
              "update:scaleValue": function($event) {
                _vm.scaleValue = $event
              },
              "update:scale-value": function($event) {
                _vm.scaleValue = $event
              },
              "pre-page": function($event) {
                return _vm.getContractDetailByNum($event)
              },
              "next-page": function($event) {
                return _vm.getContractDetailByNum($event)
              }
            }
          }),
          _c(
            "div",
            { staticClass: "contract-bottom" },
            [
              _vm.contractInfoTemporary &&
              _vm.contractInfoTemporary.items &&
              _vm.contractInfoTemporary.items > 1
                ? [
                    _c(
                      "p",
                      {
                        staticStyle: {
                          "font-weight": "bold",
                          "text-align": "center"
                        }
                      },
                      [
                        _vm._v(
                          _vm._s(_vm.currentInfo.page) +
                            "/" +
                            _vm._s(_vm.contractInfoTemporary.items)
                        )
                      ]
                    ),
                    _c(
                      "el-tooltip",
                      { attrs: { effect: "light", placement: "left-start" } },
                      [
                        _c(
                          "div",
                          { attrs: { slot: "content" }, slot: "content" },
                          [_vm._v("回到首页")]
                        ),
                        _c(
                          "span",
                          {
                            staticClass: "arrow-up",
                            on: {
                              click: function($event) {
                                return _vm.goPageAndFixed(1)
                              }
                            }
                          },
                          [
                            _c("img", {
                              attrs: {
                                src: require("../../assets/images/btn-down.png")
                              }
                            })
                          ]
                        )
                      ]
                    ),
                    _c(
                      "el-tooltip",
                      { attrs: { effect: "light", placement: "left" } },
                      [
                        _c(
                          "div",
                          { attrs: { slot: "content" }, slot: "content" },
                          [_vm._v("上一页")]
                        ),
                        _c("span", {
                          staticClass: "el-icon-arrow-up",
                          on: {
                            click: function($event) {
                              return _vm.goPageAndFixed(
                                _vm.currentInfo.page > 1
                                  ? _vm.currentInfo.page - 1
                                  : 1
                              )
                            }
                          }
                        })
                      ]
                    ),
                    _c(
                      "el-tooltip",
                      { attrs: { effect: "light", placement: "left" } },
                      [
                        _c(
                          "div",
                          { attrs: { slot: "content" }, slot: "content" },
                          [_vm._v("下一页")]
                        ),
                        _c("span", {
                          staticClass: "el-icon-arrow-down",
                          on: {
                            click: function($event) {
                              return _vm.goPageAndFixed(
                                _vm.contractInfoTemporary.items >
                                  _vm.currentInfo.page
                                  ? _vm.currentInfo.page + 1
                                  : _vm.contractInfoTemporary.items
                              )
                            }
                          }
                        })
                      ]
                    ),
                    _c(
                      "el-tooltip",
                      { attrs: { effect: "light", placement: "left-end" } },
                      [
                        _c(
                          "div",
                          { attrs: { slot: "content" }, slot: "content" },
                          [_vm._v("回到尾页")]
                        ),
                        _c(
                          "span",
                          {
                            staticClass: "arrow-down",
                            on: {
                              click: function($event) {
                                return _vm.goPageAndFixed(
                                  _vm.contractInfoTemporary.items
                                )
                              }
                            }
                          },
                          [
                            _c("img", {
                              attrs: {
                                src: require("../../assets/images/btn-down.png")
                              }
                            })
                          ]
                        )
                      ]
                    )
                  ]
                : _vm._e()
            ],
            2
          )
        ],
        1
      ),
      _c(
        "el-aside",
        {
          staticClass: "aside-right",
          class: "approve-aside",
          attrs: { width: "2.80rem" }
        },
        [
          !_vm.isInDingTalk
            ? _c("div", { staticClass: "bottom-btns" }, [
                _c(
                  "div",
                  { staticClass: "bottom_textarea" },
                  [
                    _c("span", [_vm._v("审批意见：")]),
                    _c("el-input", {
                      attrs: {
                        type: "textarea",
                        rows: "5",
                        resize: "none",
                        autofocus: true,
                        size: "small",
                        maxlength: 100,
                        placeholder: "请输入审批意见"
                      },
                      model: {
                        value: _vm.refuseModel.reason,
                        callback: function($$v) {
                          _vm.$set(_vm.refuseModel, "reason", $$v)
                        },
                        expression: "refuseModel.reason"
                      }
                    })
                  ],
                  1
                ),
                _c(
                  "p",
                  [
                    _c(
                      "el-button",
                      {
                        staticClass: "btn",
                        attrs: { type: "danger", size: "small" },
                        on: {
                          click: function($event) {
                            return _vm.clickHanldeAuditRefuse(1)
                          }
                        }
                      },
                      [_vm._v("同意")]
                    )
                  ],
                  1
                ),
                _c(
                  "p",
                  [
                    _c(
                      "el-button",
                      {
                        staticClass: "btn",
                        attrs: { size: "small" },
                        on: {
                          click: function($event) {
                            return _vm.clickHanldeAuditRefuse(2)
                          }
                        }
                      },
                      [_vm._v("拒绝")]
                    )
                  ],
                  1
                )
              ])
            : _vm._e(),
          _vm.isInDingTalk
            ? _c("div", [
                _c(
                  "p",
                  [
                    _c(
                      "el-button",
                      {
                        staticClass: "btn",
                        attrs: { type: "danger", size: "small" },
                        on: {
                          click: function($event) {
                            return _vm.dingApproval()
                          }
                        }
                      },
                      [_vm._v("审批")]
                    )
                  ],
                  1
                )
              ])
            : _vm._e()
        ]
      ),
      _c("ViewFilesToDoc", {
        attrs: {
          visibleShow: _vm.visibleShowEnclosureDoc,
          enclosurePreviewNumItem: _vm.enclosurePreviewNumItem
        },
        on: { setViewFilesToDocDialogData: _vm.onSetViewFilesToDocDialogData }
      }),
      _c("ViewFilesToImg", {
        attrs: {
          visibleShow: _vm.visibleShowEnclosure,
          isRefresh: _vm.isRefresh,
          enclosurePreviewNumItem: _vm.enclosurePreviewNumItem,
          imgList: _vm.getEnclosureImgList
        },
        on: { setViewFilesToImgDialogData: _vm.onSetViewFilesToImgDialogData }
      })
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-9e02994a", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-9e02994a","hasScoped":true,"transformToRequire":{"video":"src","source":"src","object":"src","embed":"src"},"preserveWhitespace":false,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./pages/applySign/auditMulti.vue
// module id = hcRr
// module chunks = 26